export const scoreTags = [
  { id: 1, label: '趣味嗜好補正' },
  { id: 2, label: '思い出補正' },
  { id: 3, label: 'IP・シリーズ補正' },
  { id: 4, label: 'Dev / Pub補正' },
  { id: 5, label: 'ソフトウェアバージョン補正' },
  { id: 6, label: 'マルチプレイ補正' },
  { id: 7, label: 'エントリー補正' },
  { id: 8, label: 'コンテクスト補正' },
  { id: 10, label: '期待値補正' },
  { id: 0, label: 'その他の上方バイアス' },
  { id: 31, label: '趣味嗜好補正' },
  { id: 34, label: 'Dev / Pub補正' },
  { id: 35, label: 'ソフトウェアバージョン補正' },
  { id: 36, label: 'マルチプレイ補正' },
  { id: 37, label: 'エントリー補正' },
  { id: 38, label: 'コンテクスト補正' },
  { id: 40, label: '期待値補正' },
  { id: 9, label: 'その他の下方バイアス' },
];